import EventEmitter from 'eventemitter3';

export abstract class JsBridge {
    abstract appShareUrl(url: string, ...args: unknown[]): void;
    // abstract appDirectTo(page: 'CouponList' | 'P-CardPage'): void;
    abstract appOpenExternalBrowser(url: string): void;
    abstract appGetLocalStorageDataRequest(): void;
    abstract appGetLocalStorageDataRequestAsync(): void;
    abstract appSetUiVisibility(ui: 'btnBack' | 'btnCalendar' | 'btnSkip', visable: boolean): void;
    abstract addCalendarEvent(
        title: string,
        description: string,
        eventUUID: string,
        startTime: number,
        endTime: number
    ): Promise<{ eventUUID: string; result: boolean }>;

    abstract setAllBettingStrategies(value: boolean): void;
    // abstract appSaveDiscoverPreference(data: AppLocalSetting): void; ---- 旧 废弃
    abstract appSaveDiscoverPreference(data: SendPreferenceCRMData): void;
    abstract appOpenRacingLiveStream(): void;
    abstract appOpenMsLiveStream(): void;
    abstract appOnLeavePreferencePage(): void;
    abstract appCloseNativePIP(): void;
    /**
     * True = PIP
     * False = FullScreen
     */
    abstract appOpenNativePlayer(url: string, title: string, isPip: boolean): void;
    onBackBtnClicked?: () => boolean | void;
    onCalendarBtnClicked?: () => void;
    closeNativePIP?: () => void;
    onAppDiscoverSkipBtnClicked?: () => void;
    private isGettingLocalStorage = false;

    emitter = new EventEmitter<
        {
            onLocalStorageResponse: (error?: Error, value?: AppLocalStorage) => void;
        },
        JsBridge
    >();
    constructor() {
        global.onBackBtnClicked = () => {
            try {
                return this.onBackBtnClicked && this.onBackBtnClicked();
            } catch (error) {
                console.log(error);
            }
        };
        global.appOpenDiscoverCalendar = () => {
            try {
                this.onCalendarBtnClicked && this.onCalendarBtnClicked();
            } catch (error) {
                console.log(error);
            }
        };
        global.onAppDiscoverSkipBtnClicked = () => {
            try {
                this.onAppDiscoverSkipBtnClicked && this.onAppDiscoverSkipBtnClicked();
            } catch (error) {
                console.log(error);
            }
        };

        global.appGetLocalStorageDataResponse = (jsonStringBase64) => {
            try {
                // console.log('onLocalStorageResponse', jsonStringBase64);
                const value = decodeData<AppLocalStorage>(jsonStringBase64);
                this.emitter.emit('onLocalStorageResponse', undefined, value);
            } catch (error) {
                this.emitter.emit('onLocalStorageResponse', error as Error, undefined);
            }
        };

        // global.appCloseNativePIP = () => {
        //     try {
        //         this.closeNativePIP && this.closeNativePIP();
        //     } catch (error) {
        //         console.log(error);
        //     }
        // };
    }

    async appGetLocalStorageData(): Promise<
        AppLocalStorage | OldAppLocalStorage | PreferenceDataEmpty | undefined
    > {
        const promise = new Promise<
            AppLocalStorage | OldAppLocalStorage | PreferenceDataEmpty | undefined
        >((resolve, reject) => {
            this.emitter.once('onLocalStorageResponse', (err, localstoarge) => {
                this.isGettingLocalStorage = false;
                if (err) {
                    reject(err);
                } else {
                    resolve(localstoarge);
                }
            });
        });
        if (!this.isGettingLocalStorage) {
            this.isGettingLocalStorage = true;
            // console.log('call appGetLocalStorageDataRequest---');
            this.appGetLocalStorageDataRequest(); //trigger the request
        }
        const value = await promise;
        return value;
    }

    // 测试三合一promise
    async appGetLocalStorageDataAsync(): Promise<
        AppLocalStorage | OldAppLocalStorage | PreferenceDataEmpty | undefined
    > {
        // 如果已经在获取数据，直接返回 undefined
        if (this.isGettingLocalStorage) {
            console.warn('Already fetching local storage data. Please wait.');
            return undefined;
        }

        this.isGettingLocalStorage = true; // 设置为正在获取数据

        try {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const value: any = await RNDiscoverJsBridge?.appGetLocalStorageDataRequestAsync();
            // console.log('call appGetLocalStorageDataRequestAsync---', value);
            return decodeData(value);
        } catch (error) {
            console.error('Error fetching local storage data:', error);
            throw error;
        } finally {
            this.isGettingLocalStorage = false;
        }
    }
}

/** 解密 */
export function decodeData<T>(base64Data: string | null): T | undefined {
    if (base64Data) {
        const encodedData = window.atob(base64Data);
        const encodedDataArray = Uint8Array.from(encodedData, (char) => char.charCodeAt(0));
        const decoder = new TextDecoder('utf-8');
        const jsonData = decoder.decode(encodedDataArray);
        return JSON.parse(jsonData);
    } else {
        return undefined;
    }
}
/** 加密 */
export function encodeData(data: unknown): string {
    const encoder = new TextEncoder();
    const jsonData = JSON.stringify(data);
    const encodedData = encoder.encode(jsonData);
    const encodeData = String.fromCharCode(...encodedData);
    return window.btoa(encodeData);
}

/**
 * preferences 旧数据
 {
  "preferenceData": {
    "preferences": {
      "step1": "novice",
      "step2": [
        "simulcast-race",
        "inside-the-stable",
        "trivia-fun-facts",
        "trainer-and-jockey",
        "dining-happenings"
      ],
      "step3": ["PZ", "CAS", "FCL", "HK_2020_E058"],
      "noFirstTimePreference": true
    },
    "nweUser": true,
    "steps": 1,
    "latestTrackTime": 1734939260
  }
}

 */

/**
 * preferences 新数据
 {
  "preferenceData": {
      "step1": ["novice"],
      "step2": [
        "simulcast-race",
        "inside-the-stable",
        "trivia-fun-facts",
        "trainer-and-jockey",
        "dining-happenings"
      ],
      "horses": ["h1234"],
      "trainers": ["aTester"],
      "jockeys": ["Jockey1111"],
      "music": ["Pop", "Rock"],
      "interests": ["Movie", "Music", "Pets"],
      "dining": ["Sweet", "Japanese Cuisine"],
      "noFirstTimePreference": ["true"],
      "nweUser": ["true"],
      "steps": ["1"],
      "latestTrackTime": ["1734939260"]
  }
}
 */

/** 废弃 */
export interface AppLocalSetting {
    preferences?: UserPreferenceSetting;
    newUser?: boolean;
    steps?: number;
    latestTrackTime?: number;
}

/** 为兼容CRM系统 旧数据不动，新增customerpreferences新数据--废弃 */
export interface UserPreferenceSetting {
    step1?: string;
    step2?: string[];
    step3?: string[];
    music?: string[];
    interests?: string[];
    dining?: string[];
    notFirstTimePreference?: boolean;
}
export interface NewAppLocalSetting {
    preferenceData?: SendPreferenceCRMData;
}

/** 为兼容CRM 新数据（discover使用时的数据）
 * 20250110 需变更新数据看--SendPreferenceCRMData
 */
// export interface UserCustomerPreferenceSetting {
//     step1?: string[];
//     step2?: string[];
//     horses?: string[];
//     trainers?: string[];
//     jockeys?: string[];
//     music?: string[];
//     interests?: string[];
//     dining?: string[];
//     /** boolean */
//     notFirstTimePreference?: string[];
//     /** boolean */
//     newUser?: string[];
//     /** 步骤 */
//     steps?: string[];
//     /** new Date() */
//     latestTrackTime?: string[];
// }

/** 20250110 用于兼容CRM and B&V. 新下发数据 */
export interface SendPreferenceCRMData {
    step1?: string[];
    step2?: string[];
    Horses?: string[];
    Trainers?: string[];
    Jockeys?: string[];
    Music?: string[];
    'Personal Interests'?: string[];
    'Dinning Preference'?: string[];
    /** boolean */
    notFirstTimePreference?: string[];
    /** boolean */
    newUser?: string[];
    /** 步骤 */
    steps?: string[];
    /** new Date() */
    latestTrackTime?: string[];
}

export interface PreferenceDataEmpty {
    [key: string]: any; // 可以使用任意键值对
}

export interface AppLocalStorage {
    // preferenceData?: AppLocalSetting ---旧;
    preferenceData?: SendPreferenceCRMData;
    horseRacingLiveSchedule?: HorseRacingLiveSchedule;
    MSLiveSchedule?: MSLiveSchedule;
    calendarEventUUIDList?: string[];
    wid?: string;
    useAgent?: string;
    allBettingStrategies?: boolean;
}
export interface OldAppLocalStorage {
    preferenceData?: AppLocalSetting;
    horseRacingLiveSchedule?: HorseRacingLiveSchedule;
    MSLiveSchedule?: MSLiveSchedule;
    calendarEventUUIDList?: string[];
    wid?: string;
    useAgent?: string;
}

/** 赛马直播数据 */
export interface HorseRacingLiveSchedule {
    schedules: Schedule[];
    ELVA?: {
        value: string;
    };
    racingScheduleList: RacingScheduleItem[];
    system: {
        serverTime: string;
        code: number;
        message: string;
    };
}

/** marksix（六合彩）直播数据 */
export interface MSLiveSchedule {
    schedules: Schedule[];
    ELVA?: {
        value: string;
    };
    msScheduleList: RacingScheduleItem[];
    system: {
        serverTime: string;
        code: number;
        message: string;
    };
}

export interface Schedule {
    type: 'video' | 'audio';
    startingMinutes: string;
    programDuration: number;
    active: boolean;
}

export interface RacingScheduleItem {
    date: string;
    time: string;
    endDate: string;
    endTime: string;
    languageCode: 'en' | 'hk';
    isNotice: boolean;
    isNoticeColor: string;
    blockCountryCode: string;
    isConghua: boolean;
    title: string;
}
